import { render, staticRenderFns } from "./AccessSM.vue?vue&type=template&id=8f714ed2&"
import script from "./AccessSM.vue?vue&type=script&lang=js&"
export * from "./AccessSM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports